module.exports = [
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2000",
    "Rate": 123.3
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2002-2004",
    "Rate": 115.33
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2005-2007",
    "Rate": 114.03
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2010",
    "Rate": 101.9
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2011-2013",
    "Rate": 96.17
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2014-2016",
    "Rate": 104.53
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2018",
    "Rate": 109.6
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2000",
    "Rate": 73.33
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2002-2004",
    "Rate": 76.23
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2005-2007",
    "Rate": 76.23
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2010",
    "Rate": 68.53
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2011-2013",
    "Rate": 65.7
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2014-2016",
    "Rate": 68.2
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2018",
    "Rate": 70
  }
]
